import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ClassAttendanceUpdateRequest } from "../../shared/ClassAttendanceUpdateRequest";
import { DataService_Student_Class_Attendance } from "../../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-student-edit-class-attendance",
	templateUrl: "./student-edit-class-attendance.component.html",
	styleUrls: ["./student-edit-class-attendance.component.css"],
})
export class StudentEditClassAttendanceComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private classAttendanceService: DataService_Student_Class_Attendance
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.user = this.dialogConfig.data.user;
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.SelectedEntry = this.dialogConfig.data.SelectedEntry;

		this.UpdateData();

		//Get data from DB
		this.loadClassAttendanceStatus();
		this.loadClassAttendanceExcuse();
	}

	UpdateData() {
		this.SchoolID = this.SelectedPerson.SchoolID;
		this.StudentID = this.SelectedPerson.DesignatorID;
		this.StudentName = this.SelectedPerson.PersonName;

		this.Section = this.SelectedEntry.Section;
		this.DateTime = this.SelectedEntry.EntryDateDesc;
	}

	////////////////////////////////////////
	// Data
	////////////////////////////////////////

	user: any;

	SelectedPerson: any;
	SelectedEntry: any;

	SchoolID: any;

	StudentID: any = 0;
	StudentName: any = "";
	Section: any = "";
	DateTime: any = "";

	ClassAttendanceStatusID: any;
	lstClassAttendanceStatus: any = [];

	ClassAttendanceExcuseID: any;
	lstClassAttendanceExcuse: any = [];

	////////////////////////////////////////

	////////////////////////////////////////
	// Load Data
	////////////////////////////////////////
	loadClassAttendanceStatus() {
		var result = this.classAttendanceService.ClassAttendanceStatusInfoGetList();
		result.subscribe(
			(response) => {
				this.lstClassAttendanceStatus = response;

				this.ClassAttendanceStatusID = this.lstClassAttendanceStatus[0].ClassAttendanceStatusID;

				this.ClassAttendanceStatusID = this.SelectedEntry.ClassAttendanceStatusID;
			},
			(error) => {}
		);
	}

	loadClassAttendanceExcuse() {
		var result = this.classAttendanceService.ClassAttendanceExcuseInfoGetList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstClassAttendanceExcuse = response;

				this.ClassAttendanceExcuseID = this.lstClassAttendanceExcuse[0].ClassAttendanceExcuseID;
				this.ClassAttendanceExcuseID = this.SelectedEntry.ClassAttendanceExcuseID;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////

	////////////////////////////////////////
	// Buttons
	////////////////////////////////////////
	onUpdate() {
		let parms: ClassAttendanceUpdateRequest = {
			ClassAttendanceStudentID: this.SelectedEntry.ClassAttendanceStudentID,
			ClassAttendanceStatusID: this.ClassAttendanceStatusID,
			ClassAttendanceExcuseID: this.ClassAttendanceExcuseID,
			ClassAttendanceEntryTypeID: 5,
			EntryTime: moment(new Date(this.SelectedEntry.EntryTime)).format("MM/DD/YYYY HH:mm:00"),
			c_date: moment(new Date()).format("MM/DD/YYYY HH:mm:00"), //c_date, current time
			UserID: this.user.userID,
		};

		var result = this.classAttendanceService.ClassAttendanceUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Class Attendance record was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Class Attendance Record",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////////

	////////////////////////////////////////
	// Events
	////////////////////////////////////////

	onStatusChange(val) {
		this.ClassAttendanceStatusID = val;

		this.ClassAttendanceExcuseID = this.lstClassAttendanceExcuse[0].ClassAttendanceExcuseID; //Unexcused

		for (var i = 0; i < this.lstClassAttendanceStatus.length; i++) {
			var next = this.lstClassAttendanceStatus[i];
			if (next.ClassAttendanceStatusID == this.ClassAttendanceStatusID) {
				if (String(next.ClassAttendanceStatusDesc).toLowerCase().indexOf("present") != -1) {
					this.ClassAttendanceExcuseID = -1;
				}

				break;
			}
		}
	}

	////////////////////////////////////////

	////////////////////////////////////////
	// Helpers
	////////////////////////////////////////

	DisableExcuse() {
		if (this.lstClassAttendanceStatus.length == 0 || this.ClassAttendanceStatusID == undefined) {
			return true;
		}

		for (var i = 0; i < this.lstClassAttendanceStatus.length; i++) {
			var next = this.lstClassAttendanceStatus[i];

			if (next.ClassAttendanceStatusID == this.ClassAttendanceStatusID) {
				return next.IsExcusedInd == 1 && String(next.ClassAttendanceStatusDesc).toLowerCase().indexOf("present") == -1 ? false : true;
			}
		}
	}

	////////////////////////////////////////
}
